/**
 * Reloads the app after switching organization or view, staying in the same module: everything on
 * screen belonged to the previous view.
 */
export function reloadInModule(pathname: string): void {
  const first = pathname.split("/").filter(Boolean)[0];
  window.location.assign(first ? `/${first}` : "/");
}
